import { Suspense } from 'react'
import { Outlet } from 'react-router-dom'

import { useUserCarouselsQuery } from 'api/userCarousels/queries'
import { ConversationMenuOffsetWrapper } from 'components/ConversationMenuOffsetWrapper'
import { Header } from 'components/Header'
import { PageLoader } from 'components/PageLoader'

import { PendingConversationsProvider } from 'contexts/pendingConversationsProvider'
import { initDeviceIdCookie } from 'utils/cookie'

import { AutoTriggeredUserCarousel } from './components/AutoTriggeredUserCarousel'
import { ConversationMenu } from './components/ConversationMenu'
import { HelpAndFeedbackMenu } from './components/HelpAndFeedbackMenu'

import { MainContentWrapper } from './components/MainContentWrapper'

import type { FC, PropsWithChildren } from 'react'

export const MainLayout: FC<PropsWithChildren> = () => {
  const { data: userCarousels } = useUserCarouselsQuery({
    select: data => data.userCarousels,
  })

  const autoTriggeredUserCarousel = userCarousels?.[0]?.slug

  initDeviceIdCookie()

  return (
    <PendingConversationsProvider>
      <Header />
      {autoTriggeredUserCarousel && (
        <AutoTriggeredUserCarousel carouselSlug={autoTriggeredUserCarousel} />
      )}
      <ConversationMenu />
      <ConversationMenuOffsetWrapper>
        <MainContentWrapper>
          <Suspense fallback={<PageLoader />}>
            <Outlet />
          </Suspense>
        </MainContentWrapper>
      </ConversationMenuOffsetWrapper>
      <HelpAndFeedbackMenu />
    </PendingConversationsProvider>
  )
}
